import { DefaultTheme } from '@01_people/ui-library';

export default {
  ...DefaultTheme,
  typography: {
    ...DefaultTheme.typography,
    fontPrimary: 'Roboto, sans-serif'
  },
  form: {
    separatorColor: '#e9e9e9'
  },
  colors: {
    primary: {
      color: '#346ffe'
    },
    secondary: {
      color: '#1f2c55'
    },
    error: {
      color: '#ff4747'
    },
    success: {
      color: '#00da84'
    },
    disabled: {
      color: '#d6e2fe'
    },
    gray: {
      color: '#8f9fad'
    },
    white: {
      color: '#ffffff'
    },
    black: {
      color: '#171b20'
    }
  }
};
